<template>
  <ul class="columns is-multiline is-mobile">
    <speaker
    class="column is-one-fifth-tablet is-half-mobile" :class=[status]
    v-for="(speaker, index) in speakers"
    v-if="speaker && Number(speaker.id) !== 1319"
    :data="speaker"
    :key="index"></speaker>
  </ul>
</template>

<script>
import Speaker from './speaker'

export default {
  name: 'speakers',
  components: {
    Speaker
  },
  props: [
    'speakers',
    'status'
  ],
  data () {
    return {
      curTab: 0
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
.columns
  margin-top: -1rem
  &:last-child
    margin-bottom: -1rem
  &:not(:last-child)
    margin-bottom: 30px
.column
  padding: 1rem 0.75rem
</style>
